const EventList = [
    {
        ID: 1,
        event: "Performance Appraisal",
        stdate: "21-04-2023",
        endate: "31-04-2023",
        startus: 1,   
    },
    {
        ID: 2,
        event: "HR Birthday",
        stdate: "24-04-2023",
        endate: "24-04-2023",
        startus: 1,   
    },
    {
        ID: 3,
        event: "Meeting With Sharon Vouyage",
        stdate: "21-05-2023",
        endate: "31-05-2023",
        startus: 0,   
    },
    {
        ID: 4,
        event: "Executive Meeting With ATCT",
        stdate: "21-05-2023",
        endate: "31-05-2023",
        startus: 1,   
    },
    {
        ID: 5,
        event: "Executive Meeting With Team from the American Embassy",
        stdate: "13-04-2023",
        endate: "13-04-2023",
        startus: 0,   
    },
]

export default EventList